<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Permohonan Tanda Tangan"
        class="card-wrapper"
        >
        <form>
          <v-alert v-if="bulkFinishedCount > 0" border="left" type="info">
            <div>{{ bulkFinishedMessage }}</div>
            <ul v-for="(item, index) in finishedList" :key="index">
              <li>Nomor Surat <b>{{ item.nomor_surat }}</b> urutan ke-{{ item.urutan_ttd }} sebagai {{ item.tipe_ttd == 1 ? 'Pemaraf' : 'Penandatangan' }}</li>
            </ul> 
            <v-divider class="my-4 info" style="opacity: 0.22"></v-divider> 
            <v-row align="center">
              <v-col class="grow">
                Klik 'x' untuk membersihkan notifikasi
              </v-col>
              <v-col class="shrink">
                <v-btn fab x-small color="white" @click="removeNotification()"><v-icon size="20" color="info">mdi-window-close</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <v-alert v-if="confirmRejectCount > 0" border="left" type="success">
            <div>{{ confirmRejectMessage }}</div>
            <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
            <v-row align="center" v-for="i in confirmRejectList" :key="i">
              <v-col class="grow">
                Klik detail untuk melihat proses penandatanganan dengan nomor surat <b>{{ i.nomor_surat }}</b>
              </v-col>
              <v-col class="shrink">
                <v-btn color="info" @click="detailNotification(i)">Detail</v-btn>
              </v-col>
            </v-row>
          </v-alert>

          <v-alert v-if="denyRejectCount > 0" border="left" type="warning">
            <div>
              {{ denyRejectMessage }}
            </div>
          </v-alert>

          <!-- <p>Menolak</p>
          {{ confirmRejectList }}
          <p>Tidak dapat ditolak</p>
          {{ idTtdDenyRejectList }} -->
          <esign-filter-panel>
          <div style="height: 80px" class="form-input row">
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Username Pengaju</p>
              <v-text-field
                  v-model="searchForm.usernamePengaju"
                  placeholder="Username"
                  dense
                  outlined
                  clearable
              />
            </div>
            <!-- <div class="col-3">
              <p class="label font-weight-bold mb-1">Nomor Pengajuan</p>
              <v-text-field
                outlined
                placeholder="Nomor Pengajuan"
                clearable
                dense
                  v-model="searchForm.nomorPengajuan"
              /> 
            </div> -->
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Nomor Surat</p>
              <v-text-field
                outlined
                placeholder="Nomor Surat"
                clearable
                dense
                  v-model="searchForm.nomorSurat"
              /> 
            </div>
          </div>
          <div style="height: 80px" class="form-input row">
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Jenis Dokumen</p>
              <v-autocomplete
                :items="filteredJenisDokumen"
                :item-text="item => item.nama"
                :item-value="item => item.id"
                no-data-text="Tidak ada data"
                placeholder="Pilih Jenis Dokumen"
                clearable
                dense
                outlined
                v-model="searchForm.jenisDokumen"
                @keydown.enter.prevent
              ></v-autocomplete>
            </div>
            <div class="col-3">
              <p class="label font-weight-bold mb-1">Tanggal Pengajuan</p>
              <v-text-field
                type="date"
                outlined
                clearable
                dense
                  v-model="searchForm.tanggalPengajuan"
              /> 
            </div>
            <div class="col-4">
              <p class="label font-weight-bold mb-1"><br></p>
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="searchDokumen()"
              >
                Cari
              </v-btn>
            </div>
          </div>
          </esign-filter-panel>
          <br>
        </form>
        <v-card>
            <div class="col-8">
              <v-text-field
              v-model="search"
              class="esign-table-search"
              prepend-inner-icon="mdi-magnify"
              label="Cari di tabel"
              outlined
              dense
              clearable
              single-line
              hide-details
            ></v-text-field>
            </div>
            <v-data-table
                :headers="headers"
                :search="search"
                :items="items"
                no-data-text="Tidak ada data"
                no-results-text="Data tidak ditemukan"
                class="elevation-1"
                :loading="isLoading"
                loading-text="Memuat data..."
                :options.sync="options"
                show-select
                v-model="selected"
                item-key="id_ttd_arsip_dokumen"
                @toggle-select-all="selectAllToggle"
                :item-class="itemDenyReject"
                selectable-key="selectable"
                hide-default-footer  
            >
              <template v-slot:footer="{ props, on }">
                <esign-table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update:options="on['update:options']"
                />
              </template>
              <template v-slot:item.status_dokumen="{ item }">
                <esign-status-tag :value="item.status_dokumen" />
              </template>
                <template
                    v-for="header in headers.filter((header) =>
                      header.hasOwnProperty('formatter')
                    )"
                    v-slot:[`item.${header.value}`]="{ header, value }"
                  >
                    {{ header.formatter(value) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-row>
                    <v-btn style="margin:auto" small color="primary" dark @click="detailItem(item)">Detail</v-btn>
                  </v-row>
                </template>
                <template v-slot:item.keterangan_urutan="{ item }">
                  <esign-status-tag :tone="item.flag_urutan ? 'success' : 'warning'" :value="item.keterangan_urutan" />
                </template>
            </v-data-table>
            <div class="row ma-0 px-1 pt-3 esign-sign-bar" v-if="selected.length > 0">
              <!-- <div class="col-5"></div> -->
              <div class="col-2">
                  <h4 dense class="label" style="padding-top:0.5em">Input Passphrase</h4>
              </div>
              <div class="col-3">
                  <v-text-field
                      type="password"
                      v-model="passphrase"
                      dense
                      clearable
                      outlined
                      autocomplete="off"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                  />
              </div>
              <div class="col-2">
                <v-btn style="min-width:120px" color="primary" @click="validate_sign()">{{ computedText }}</v-btn>
                <!-- <v-btn style="min-width:120px" color="primary" @click="sign()">{{ computedText }}</v-btn>  -->
                <!-- <v-btn v-if="this.countCheck > 0" style="min-width:120px" color="green" @click="sign()">Tanda tangani {{ this.countCheck }} dokumen</v-btn>  -->
              </div>
            </div>
        </v-card>
        
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        </material-card>
        <v-overlay
          :opacity="0.5"
          :value="overlay"
        >
          <v-progress-circular indeterminate size="64">
            Loading...
          </v-progress-circular>
        </v-overlay>
    </v-container>
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";
var moment = require('moment');
export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["search", "searchForm", "options"],
  data: () => ({
    search: "",
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    isLoading: true,
    menu: false,
    dialog: false,
    showPassword: false,
    jenisDokumens: [],
    statusDokumens: [],
    items: [],
    selected: [],
    headers: [
        // { text: "Nomor Pengajuan", value: "nomor_pengajuan", cellClass: "esign-cell-break" },
        { text: "Tanggal Pengajuan", value: "tanggal_pengajuan", sortable: true, formatter: (x) => (x ? moment.utc(x).locale("id").format('DD-MM-YYYY HH:mm:ss') : null) },
        { text: "Nomor Surat", value: "nomor_surat", cellClass: "esign-cell-break" },
        { text: "Jenis Dokumen", value: "nama_jenis_dokumen"},
        { text: "Nama Organisasi", value: "nama_organisasi"},
        // { text: "id arsip", value: "id_arsip"},
        // { text: "id ttd", value: "id_ttd_arsip_dokumen"},
        // { text: "id penttd", value: "id_penandatangan"},
        { text: "Username Pengaju", value: "username_pengaju"},
        { text: "Alur", value: "alur_persetujuan"},
        { text: "Sumber", value: "source"},
        { text: "Status", value: "status_dokumen"},
        { text: "Keterangan", value: "keterangan_urutan"},
        // { text: '', value: 'data-table-select' },
        { text: "Aksi", align:"center", value: "action", sortable: false}
    ],
    searchForm: {
      nomorSurat: "",
      usernamePengaju: "",
      jenisDokumen: -1,
      tanggalPengajuan: null,
    //   statusDokumen: -1,
      userId: -1,
      organisasi: -1
    },
    overlay: false,
    countCheck: 0,
    isRahasia: false,
    countRahasia: 0,
    signButtonText: "",
    signForm: [],
    passphrase:"",
    options: {},
    totalData: 0,
    tgl:null,
    // bulk_list: [],
    ttd_bulk: false,
    peran: "",
    user: null,
    confirmRejectMessage:"",
    denyRejectMessage:"",
    confirmRejectCount:0,
    denyRejectCount:0,
    confirmRejectList:[],
    idTtdDenyRejectList:[],
    finishedList: [],
    bulkFinishedMessage:"",
    bulkFinishedCount:0,
  }),
  computed: {
    filteredJenisDokumen(){
        return this.jenisDokumens.filter(item => item.status)
    },
    computedText(){
        let jumlah_sign = this.selected.length
        let text = jumlah_sign > 1 ? "Tanda tangani " + jumlah_sign + " dokumen"  : "Tanda tangan"
        return text
    }
  },
  created() {
    this.peran =localStorage.getItem("currentPeran")
    this.user= JSON.parse(localStorage.getItem("user"))
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    this.getDropdownJenisDokumen()
    // this.getDropdownStatusDokumen()
    if (this.peran!='A03') {
        this.$router.push('/403')
      }
    this.searchForm.userId = this.user.id
    // paging/sorting is done by the table itself, so the list is loaded once
    this.getData()
    this.getNotificationAlert()
    this.getBulkNotificationAlert()
  },
  methods: {
    selectAllToggle(props) {
      let availableItems = props.items.filter(item => item.selectable)

      if (this.selected.length !== availableItems.length) {
        this.selected = [...availableItems]
      } else {
        this.selected = []
      }
    },
    getData() {
      this.isLoading = true;
      let tanggal_pengajuan = null
      if (this.searchForm.tanggalPengajuan) {
        tanggal_pengajuan = moment(this.searchForm.tanggalPengajuan).format('DD-MM-YYYY')
      }
      apiServer
        .get("/arsip/sign_list", {
          params: {
            nomor_surat: this.searchForm.nomorSurat,
            username_pengaju: this.searchForm.usernamePengaju,
            id_jenis_dokumen: this.searchForm.jenisDokumen,
            tanggal_pengajuan: tanggal_pengajuan,
            id_status_dokumen: this.searchForm.statusDokumen,
            id_pengguna: this.searchForm.userId,
            id_organisasi: this.searchForm.organisasi,
          }
        })
        .then(response => {
          this.isLoading = false;
          this.items = response.data.data;
          this.modifyColumn()
          this.totalData = this.items.length
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    itemDenyReject(item) {
      if (this.idTtdDenyRejectList.includes(item.id_ttd_arsip_dokumen)) {
        return 'deny-reject'
      }
    },
    getNotificationAlert() {
      apiServer
        .get("/arsip/confirm_or_deny_reject_list", {
          params: {
            id_penandatangan_login: this.user.id
          }
        })
        .then(response => {
          var confirm_or_deny_reject_list = response.data.data;
          for(let item of confirm_or_deny_reject_list){
            if (item.keterangan != "") {
              this.confirmRejectCount++
              this.confirmRejectList.push(item)
              // this.idConfirmRejectList.push(item.id_ttd_arsip_dokumen)
            } else {
              this.denyRejectCount++
              this.idTtdDenyRejectList.push(item.id_ttd_arsip_dokumen)
            }
          }
          this.confirmRejectMessage = 'Terdapat ' + this.confirmRejectCount + ' penolakan yang disetujui oleh pengaju'
          this.denyRejectMessage = 'Terdapat ' + this.denyRejectCount + ' penolakan yang disanggah oleh pengaju karena terdapat visual paraf/tanda tangan Anda. Silakan lihat baris yang diberi highlight'
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    getBulkNotificationAlert() {
      apiServer
        .get("/arsip/finished_list_bulk", {
          params: {
            id_penandatangan_login: this.user.id
          }
        })
        .then(response => {
          this.finishedList = response.data.data
          this.bulkFinishedCount = this.finishedList.length
          this.bulkFinishedMessage = "Terdapat " + this.bulkFinishedCount + " permohonan berhasil ditandatangani dengan detail: "
          // if (this.bulkFinishedCount > 0) {
          //   const nomorSurats = this.finishedList.map(function(i) {
          //       return i.nomor_surat
          //   })
          //   this.bulkFinishedMessage = "Terdapat " + this.bulkFinishedCount + " permohonan berhasil ditandatangani dengan nomor surat: " + nomorSurats.join(", ")
          // }
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    removeNotification() {
      var removedList = [] 
      for(let item of this.finishedList){
        removedList.push({
          id_ttd_arsip_dokumen: item.id_ttd_arsip_dokumen
        })
      } 
      apiServer
        .put("/arsip/remove_notification_bulk", removedList)
        .then(response => {
          console.log(response)
          if (response.data.status == 'ok') {
              this.$router.go('/sign');  
            }
        })
        .catch(error => {
          console.log("There was an error:", error); // Logs out the error 
        });
    },
    isSingleJenis() {
        let single_jenis = false;
        if (this.totalData == 1) { 
          single_jenis = true }
        else {
          const idJenisDokumens = this.items.map(function(i) {
            return i.id_jenis_dokumen
          })
          const uniqueElements = [...new Set(idJenisDokumens)]
          console.log("uniq: " + JSON.stringify(uniqueElements))
          if (uniqueElements.length == 1) {
              single_jenis = true 
          } else {
              single_jenis = false 
          } 
        }
    },
    refreshTable() {
      this.selected = []
      this.getData()
    },
    modifyColumn() {
      this.items.forEach((item, _) => {
        if(item.alur_persetujuan !== 'Berjenjang') {
          if (item.flag_urutan) {
            if (item.flag_on_process) {
              item.selectable = false
              item.keterangan_urutan = "Dalam Proses"
            } else {
              item.selectable = true
              item.keterangan_urutan = "Sesuai Urutan"
            }
          }
        }

        if(item.alur_persetujuan === 'Berjenjang') {
          if (item.flag_urutan) {
            if (item.flag_on_process) {
              item.selectable = false
              item.keterangan_urutan = "Dalam Proses"
            } else {
              item.selectable = true
              item.keterangan_urutan = "Sesuai Urutan"
            }
          } else {
            item.selectable = false
            item.keterangan_urutan = "Menunggu urutan penandatangan"
          }
        }
      })
    },
    getDropdownJenisDokumen() {
      apiServer
        .get("/arsip/dropdown_jenis_dok")
        .then(response => {
          this.jenisDokumens = response.data.data;
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    getDropdownStatusDokumen() {
      apiServer
        .get("/arsip/dropdown_status_dok")
        .then(response => {
          // console.log("status: "+ JSON.stringify(response.data.data))
          this.statusDokumens = response.data.data;
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    tick() {
        var jumlah_sign = this.selected.length
        this.countRahasia = 0
        for(let item of this.selected){
          if(item.id_kerahasiaan == 1) {
            this.countRahasia ++
          }
        }
        this.signButtonText = jumlah_sign > 1 ? "Tanda tangani " + jumlah_sign + " dokumen"  : "Tanda tangan" 
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    searchDokumen(){
      console.log("search"+JSON.stringify(this.searchForm))
      // this.search = ""
      if (!this.searchForm.jenisDokumen) {
        this.searchForm.jenisDokumen = -1
      }
    //   if (!this.searchForm.statusDokumen) {
    //     this.searchForm.statusDokumen = -1
    //   }
      this.options.page = 1
      this.getData()
    },
    validate_sign() {
      this.overlay = true
      this.validSignForm() 
      if (this.countRahasia > 0 && this.passphrase === "") {
          this.showSnackbar("error", "Dokumen bersifat rahasia dan sangat rahasia membutuhkan passphrase")
          this.overlay = false
      } else {
        apiServer.put("/arsip/validate_sign_bulk", this.signForm)
        .then(response => {
          this.overlay = false
          if (response.data.status === 'ok') {
            localStorage.setItem("success", this.signForm.length + " Dokumen sedang diproses tandatangan, silakan menunggu notifikasi")
            this.$router.go('/sign');
            this.sign()
          } else {
            this.showSnackbar("error", response.data.message)
          }
          this.refreshTable()
        })
        .catch(error => {
          this.isLoading = false;
          this.overlay = false
          this.showSnackbar("error", error.response.data.message);
        }); 
      }
    },
    async sign() { 
      console.log("signing id_ttd_arsip_dokumen: " + JSON.stringify(this.signForm) + "length: " + this.signForm.length)
      try {
          const response = await apiServer.put("/arsip/sign_bulk", this.signForm) 
      } catch (error) {
          console.error(error);
      }
    },
    validSignForm() {
      this.signForm = []
      this.selected.forEach((item, index) => {
          this.signForm.push({
            id_arsip_dokumen: item.id_arsip,
            nomor_pengajuan: item.nomor_pengajuan,
            alur_persetujuan: item.alur_persetujuan,
            nama_jenis_dokumen: item.nama_jenis_dokumen,
            id_jenis_dokumen_organisasi: item.id_jenis_dokumen_organisasi,
            id_ttd_arsip_dokumen: item.id_ttd_arsip_dokumen,
            username_pengaju: item.username_pengaju,
            id_user_login: this.user.id,
            username_login: this.user.username,
            passphrase: this.passphrase,
            nik: this.user.pengguna.nik
          })
      })
    },
    testEmail() {
      apiServer
        .get("/arsip/test_email")
        .then(response => {
          console.log("Response: ", response.data.data); // Logs out the error
          this.isLoading = false;
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    detailItem(item) {
      this.$router.push('/dokumen/detail/'+item.id_arsip);
    },
    detailNotification(item) {
      // console.log(item.status_dokumen == "Selesai")
      if (item.status_dokumen == "Selesai") {
        apiServer
          .put("/arsip/update_time/" + item.id_ttd_arsip_dokumen)
          .then(response => {
            if (response.data.code == 200) {
              this.$router.push('/dokumen/detail/'+item.id_arsip);
              window.location.reload();
            }
          })
          .catch(error => {
            console.log("There was an error:", error.response);
          });
      } else {
        this.$router.push('/dokumen/detail/'+item.id_arsip);
      }
    }
  }
};
</script>

<style>
    .deny-reject {
      background-color: rgb(250, 198, 170)
    }
</style>